import { useCallback, useEffect, useState } from 'react';
import { pontoApi, type ColaboradorPontoStatus } from '@/features/ponto/api/pontoApi';
import { useSyncReload } from '@/shared/hooks/useSyncReload';

type Estado = {
  status: ColaboradorPontoStatus[];
  carregando: boolean;
  erro: string | null;
};

export function usePontoStatus() {
  const [estado, setEstado] = useState<Estado>({
    status: [],
    carregando: false,
    erro: null,
  });

  const recarregar = useCallback(() => {
    setEstado((s) => ({ ...s, carregando: true, erro: null }));
    return pontoApi.status().then(
      (status) => setEstado({ status, carregando: false, erro: null }),
      (e: unknown) => {
        const mensagem = e instanceof Error ? e.message : 'Erro desconhecido';
        setEstado((s) => ({ ...s, carregando: false, erro: mensagem }));
      },
    );
  }, []);

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  useSyncReload(recarregar);

  return { ...estado, recarregar };
}
